
import { BUSINESS_UNIT_METADATA } from './business-unit.metadata';
import { BusinessUnitBase } from './business-unit.model.base';
import { CrudEntity, CrudEntityConstructionOptions } from '@scisys-uim/uim-common';


export interface BusinessUnit extends BusinessUnitBase {
}

export interface BusinessUnitTransient { }

export class BusinessUnit extends CrudEntity<BusinessUnit, string, BusinessUnitTransient> implements BusinessUnitTransient {
  constructor(source?: Partial<BusinessUnit>, options?: CrudEntityConstructionOptions<BusinessUnit, string, BusinessUnitTransient>) {
    super(BUSINESS_UNIT_METADATA, source, options);
  }

  initialiseEntityDefaults() {
    super.initialiseEntityDefaults();
  }

  registerPropertyCalculators() {
    super.registerPropertyCalculators();
  }
}





